import { Button } from '@mui/material';
import cn from 'classnames';
import { FC } from 'react';

import styles from './MethodReceiving.module.sass';

interface IButtons {
  handleActiveCity: (active: 'first' | 'second' | 'third') => void;
  activeCity: 'first' | 'second' | 'third';
  tab: boolean;
}
const Buttons: FC<IButtons> = ({ handleActiveCity, activeCity, tab }) => {
  return (
    <div className={styles.buttons}>
      {!tab && (
        <>
          <button
            className={cn(styles.button, {
              [styles.active]: activeCity === 'first',
            })}
            onClick={() => handleActiveCity('first')}
            type="button"
          >
            г. Владивосток
          </button>
          <button
            className={cn(styles.button, {
              [styles.active]: activeCity === 'second',
            })}
            onClick={() => handleActiveCity('second')}
            type="button"
          >
            г. Уссурийск
          </button>
          <button
            className={cn(styles.button, {
              [styles.active]: activeCity === 'third',
            })}
            onClick={() => handleActiveCity('third')}
            type="button"
          >
            г. Находка
          </button>
        </>
      )}
      {tab && (
        <button
          className={cn(styles.button, {
            [styles.active]: activeCity === 'first',
          })}
          onClick={() => handleActiveCity('first')}
          type="button"
        >
          г. Владивосток
        </button>
      )}
    </div>
  );
};

export default Buttons;
